import "./_blocLabel.scss";

import cx from "classnames";

const BlocLabelVariant = (variant: string): object => {
  return {
    "blocLabel-primary": variant.includes("primary"),
    "blocLabel-secondary": variant.includes("secondary"),
  };
};

function BlocLabel({
  label = "",
  variant = "primary",
}: {
  label?: string;
  variant?: string;
}): JSX.Element {
  return (
    <div className={cx("blocLabel", BlocLabelVariant(variant))}>
      <h3>{label}</h3>
    </div>
  );
}

export default BlocLabel;
